import { useQuery } from '@tanstack/react-query';
import { getAllUserEventSessions } from '../services/users';

const useGetUserEventSessions = (userId: string, eventId?: string | undefined) => {
  const { isLoading, data } = useQuery(['userEventSessions', userId], async () => await getAllUserEventSessions(userId, eventId), {
    enabled: !!userId,
  });

  return {
    isLoading,
    data,
  };
};

export default useGetUserEventSessions;
